<template>
  <div class="million-read-certificate-list">
    <div class="million-read-certificate-list-header">
      <div class="million-read-certificate-list-header-bar">
      </div>
      <div class="million-read-certificate-list-header-info">
        <div class="million-read-certificate-list-header-name">我的证书</div>
        <div class="million-read-certificate-list-header-count">
          已获得<span>{{ count }}</span>张证书
        </div>
      </div>
    </div>
    <ym-loadmore v-if="list.length > 0"
                 v-model="loading"
                 :finished="allLoad"
                 @load="fetchData"
    >
      <div class="million-read-certificate-list-block"
           :class="{ 'show-year': !block.hideYear }"
           v-for="(block, blockIndex) in list"
           :key="blockIndex"
      >
        <div class="million-read-certificate-list-block-received-time">
          <div class="year"
               :class="{ 'hidden': block.hideYear }"
          >
            {{ block.receiveTime|formatTime('yyyy') }}
          </div>
          <div class="month">
            {{ block.receiveTime|formatTime('MM') }}月
          </div>
        </div>
        <div class="million-read-certificate-list-block-container">
          <div class="million-read-certificate-list-item"
               v-for="(item, index) in block.data"
               :key="index"
               @click="handleClickItem(item.id)"
          >
            <ym-img class="cover"
                    :src="item.src"
            />
            <span class="title">{{ item.title }}</span>
            <span class="time">{{ item.receiveTime | formatTime('yyyy-MM-dd') }}获得</span>
          </div>
        </div>
      </div>
    </ym-loadmore>
    <empty-page v-else
                hint="没有相关证书哦~"
                type="million-read"
    />
  </div>
</template>

<script>
  import { Loadmore } from '@ymba/ym-ui';
  import EmptyPage from '@/components/EmptyPage';
  import { getCertificateList } from '@/services/million-read';
  import { LIMIT } from '@/utils/constant';
  import { formatYear } from '@/utils';

  export default {
    name: 'MillionReadCertificateList',
    metaInfo: {},
    components: {
      EmptyPage,
      'ym-loadmore': Loadmore,
    },
    data() {
      return {
        start: 0,
        list: [],
        count: 0,
        loading: false,
        allLoad: false,
      };
    },
    watch: {},
    methods: {
      async fetchData(isLoadMore = true) {
        if (this.allLoad) return;
        this.loading = true;
        const data = await getCertificateList({
          limit: LIMIT,
          start: this.start,
        }, isLoadMore);

        if (data.list.length === 0) {
          this.allLoad = true;
          this.loading = false;
          return;
        }
        this.list = formatYear([...this.list, ...data.list], 'receiveTime');
        this.count = data.count;
        this.start = data.start;
        this.loading = false;
      },
      handleClickItem(id) {
        this.$router.push({ name: 'MillionReadCertificateShare', query: { id } });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';
  .million-read-certificate-list {
    min-height: 100%;
    background: @color-white;

    &-header {
      &-bar {
        box-sizing: border-box;
        width: 100%;
        height: 88px;
        padding-left: @size-base;
        background: #fed100;
      }
      &-info {
        box-sizing: border-box;
        width: 100%;
        height: 298px;
        padding: 72px 0 0 62px;
        background: url('~@/assets/img/million_read/certificate_header.png');
        background-size: contain;
      }
      &-name {
        margin-bottom: 16px;
        color: @color-text-base;
        font-size: @font-size-extra-extra-large;
        font-weight: @font-weight-strong;
        line-height: 1;
      }
      &-count {
        box-sizing: border-box;
        width: fit-content;
        height: 40px;
        padding: 7px 16px;
        display: flex;
        align-items: center;
        color: @color-text-base;
        font-size: 26px;
        font-weight: @font-weight-strong;
        line-height: 1;
        background: linear-gradient(180deg, #fff5dd 0%, #ffe9c0 100%);
        box-shadow: 0 10px 20px 0px rgba(255, 190, 0, 0.5), 0 2px 5px 0px rgba(255, 255, 255, 0.5);
        border-radius: 23px;
        span {
          display: inline;
          margin: 0 @size-extra-small;
          color: #c97e08;
        }
      }
    }
    &-block {
      box-sizing: border-box;
      width: 100%;
      margin-bottom: @size-base;
      display: flex;
      align-items: flex-start;
      background: @color-white;
      &:first-child {
        margin-top: -46px;
        padding-top: 68px;
        border-radius: 20px 0 0 0;
      }
      &.show-year {
        padding-top: 168px;
      }

      &-received-time {
        box-sizing: border-box;
        flex-shrink: 0;
        width: 120px;
        .year {
          box-sizing: border-box;
          width: 112px;
          height: 48px;
          margin: -88px 0 48px 0;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-text-base;
          font-size: 26px;
          font-weight: @font-weight-strong;
          line-height: 1;
          background: #ffe154;
          border-radius: 0 50px 50px 0;
          &.hidden {
            display: none;
          }
        }
        .month {
          overflow: hidden;
          color: @color-text-base;
          font-size: @font-size-large;
          font-weight: @font-weight-strong;
          line-height: 1;
          text-align: center;
        }
      }
      &-container {
        display: flex;
        flex-wrap: wrap;
      }
    }
    &-item {
      margin-bottom: 70px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      &:nth-child(n) {
        margin-right: @size-base;
      }
      .cover {
        width: 280px;
        height: 198px;
      }
      .title {
        margin-top: 16px;
        color: @color-text-base;
        font-size: @font-size-base;
        font-weight: @font-weight-strong;
        line-height: 1;
      }
      .time {
        margin-top: @size-extra-small;
        color: @color-text-lighter;
        font-size: @font-size-small;
        line-height: 1;
      }
    }
  }

</style>
